export default {
  name: 'services', // do not change
  pageTitle: 'Certs',
  header: 'My certifications',
  icon: 'mdi-certificate',

  footer: '',
  products: [
    {
        title: 'Red Hat Certified Architect in Infrastructure',
        icon: 'mdi-redhat',
        date: '31 oct 2022',
        issuedBy: 'Red Hat',
        description: 'Issued by Redhat on 31 oct 2022'
      },
      {
        title: 'Red Hat Certified Specialist in Enterprise Application Server Administration',
        date: '05 jul 2023',
        icon: 'mdi-redhat',
        issuedBy: 'Red Hat',
        description: 'Issued by Red Hat on 05 jul 2023'
      },
      {
        title: 'Red Hat Certified Instructor',
        date: '31 oct 2022',
        icon: 'mdi-redhat',
        issuedBy: 'Red Hat',
        description: 'Issued by Red Hat on 31 oct 2022'
      },
      {
        title: 'Red Hat Certified Specialist in MultiCluster Management',
        date: '31 oct 2022',
        icon: 'mdi-redhat',
        issuedBy: 'Red Hat',
        description: 'Issued by Red Hat on 31 oct 2022'
      },
      {
        title: 'Red Hat Certified in Openshift Data Foundation',
        date: '05 oct 2022',
        icon: 'mdi-redhat',
        issuedBy: 'Red Hat',
        description: 'Issued by Red Hat on 05 oct 2022'
      },
      {
        title: 'Certified Kubernetes Administrator',
        icon: 'mdi-kubernetes',
        date: '14 may 2022',
        issuedBy: 'The Linux Foundation',
        description: 'Issued by The Linux Foundation on 14 may 2022'
      },
      {
        title: 'Red Hat Certified Specialist in OpenShift Application Development',
        icon: 'mdi-redhat',
        date: '10 jan 2022',
        issuedBy: 'Red Hat',
        description: 'Issued by Red Hat on 10 jan 2022'
      },
      {
        title: 'Red Hat Certified Specialist in Openshift Administration',
        icon: 'mdi-redhat',
        date: '21 jul 2021',
        issuedBy: 'Red Hat',
        description: 'Issued by Red Hat on 21 jul 2021'
      },
      {
        title: 'Red Hat Certified Engineer',
        icon: 'mdi-redhat',
        date: '28 apr 2021',
        issuedBy: 'Red Hat',
        description: 'Issued by Red Hat on 28 apr 2021'
      },
      {
        title: 'Red Hat Certified Specialist in Containers and Kubernetes',
        icon: 'mdi-redhat',
        date: '07 apr 2021',
        issuedBy: 'Red Hat',
        description: 'Issued by Red Hat on 07 apr 2021'
      },
      {
        title: 'Red Hat Certified System Administrator',
        icon: 'mdi-redhat',
        date: '21 apr 2021',
        issuedBy: 'Red Hat',
        description: 'Issued by Red Hat on 21 apr 2021'
      }
  ]
};
